import { isNil } from "lodash-es";
import { INGPageTemplateProps } from "../../library/NGFieldExtensions";
import NGAppBar from "../NGAppBar/NGAppBar";
import NGDrawer from "../NGDrawer/NGDrawer";

import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import NGReference from "../../generators/NGReference";
import { filterEmpty } from "../../library/metadataUtils";
import { getsxObject } from "../../library/utils";
import { getState } from "../../library/dataService";

export default function NGPageTemplate({ config, context }: INGPageTemplateProps) {
  const { global } = getState(context);
  const menu = global.Menu.value;
  useEffect(() => {
    const metaTag = document.createElement("meta");
    metaTag.name = "viewport";
    metaTag.content = "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no";
    document.head.appendChild(metaTag);

    return () => {
      document.head.removeChild(metaTag);
    };
  }, []);

  if (config.Header) config.Header.Anchor = "top";
  if (config.Footer) config.Footer.Anchor = "bottom";

  const drawerWidth = 0;
  const appBarHeight = "64px";
  const appBarHeightXS = "56px";
  let paddingTop: any = { xs: appBarHeightXS, sm: appBarHeight };

  if (config.HeaderHeight) {
    paddingTop = config.HeaderHeight;
  }

  if (!isNil(config.LeftSidebar)) config.LeftSidebar.MarginTop = appBarHeight;

  return (
    <>
      <CssBaseline />
      {filterEmpty(config.TopAppBar) && (
        <NGAppBar
          config={config.TopAppBar}
          context={context}
          menu={menu}
          handleClose={() => {
            console.log("Menu close");
          }}
        />
      )}
      {config.Header && <NGDrawer config={config.Header} context={context} />}

      {config.LeftSidebar && <NGDrawer config={config.LeftSidebar} context={context} />}
      <Box
        component="main"
        sx={{
          width: "100vw", //`calc(100vw - ${drawerWidth}px)` },
          paddingLeft: { sm: `${drawerWidth}px` },
          paddingTop: paddingTop,
        }}
      >
        <Outlet />

        {/* {config.Footer && <NGDrawer config={config.Footer} context={context} />} */}
        {config.Footer && (
          <Box
            sx={getsxObject(config.Footer.Style, {
              flexShrink: 0,
              [`& .MuiDrawer-paper`]: {
                width: config.Footer.Width,
                boxSizing: "border-box",
                height: config.Footer.Height,
                marginLeft: config.Footer.MarginLeft,
                marginRight: config.Footer.MarginRight,
                marginTop: config.Footer.MarginTop,
                marginBottom: config.Footer.MarginBottom,
              },
            })}
          >
            {config.Footer.ComponentName && (
              <NGReference
                config={
                  {
                    __typename: "Reference",
                    Id: config.Footer.Id + "_ref",
                    ReferenceType: "Component",
                    ReferenceId: config.Footer.ComponentName,
                  } as any
                }
                context={context}
              />
            )}
          </Box>
        )}
      </Box>
    </>
  );
}

// TODO: Add other sidebars, footers, etc. as needed
/*       <>
        { config.Header && <NGDrawer config={config.Header} /> }
        {
            config.TopAppBar && 
            <NGAppBar menu={menu} handleClose={ () => { console.log("Menu close") } }  />  
        }
        { config.LeftSidebar && <NGDrawer config={config.LeftSidebar} /> }
        <main>
        <div style={{ width: "100%", height: "100%", padding: "10px" }}>

                    {children}
        </div>
        </main>
        { config.Footer && <NGDrawer config={config.Footer} /> }
        {
            config.BottomAppBar && 
            <NGAppBar menu={menu} handleClose={ () => { console.log("Menu close") } } />  
        }
        </>
        */
